module.exports = __webpack_public_path__ + "assets/img/relate_pda_module.f36cbbbb.png";